import { Field } from "formik";

const CustomCheckBox = ({ name, checked, label, handleChange }) => {
  return (
    <label className="flex items-center">
      <Field
        type="checkbox"
        name={name}
        checked={checked}
        onChange={handleChange}
        className="text-indigo-600 !rounded focus:ring-0 focus:outline-indigo-300 cursor-pointer"
      />
      <div className="ml-3">
        <h6 className="text-sm font-normal">{label}</h6>
      </div>
    </label>
  );
};

export default CustomCheckBox;
